import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { ClubSelection } from '@screens';
import { activeUserIdAtom } from '@store';

import { LINKS } from '../utils/routes';

export const ClubSelectionScreen = () => {
    const activeUserId = useAtomValue(activeUserIdAtom);
    const navigate = useNavigate();
    return <ClubSelection activeUserId={activeUserId} onClose={() => navigate(LINKS.getFullActivity())} />;
};
